import ApplicationComponent from "legacy/ApplicationComponent"
import ChargeItemForm from "legacy/charge-item/ChargeItemForm"
import ChargeItemsList from "legacy/charge-item/ChargeItemsList"
import SortButtonsBar from "legacy/charge-item/SortButtonsBar"
import {
  afterSetState,
  buildRoute,
  isListedPumpPrice,
  orderBy,
} from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class ChargeItemsController extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      chargeItem: null,
      showForm: false,
      lastUpsertedItemId: null,
      chargeItems: this.props.chargeItems,
      listedPumpPriceLastUpdatedAt: this.props.listedPumpPriceLastUpdatedAt,
      sort: "createdAt",
      sortOrder: "desc",
      processingDelete: false,
      searchTerm: this.props.searchTerm,
    }
    this.showForm = this.showForm.bind(this)
    this.handleCreateChargeItem = this.handleCreateChargeItem.bind(this)
    this.handleUpdateChargeItem = this.handleUpdateChargeItem.bind(this)
    this.handleDeleteChargeItem = this.handleDeleteChargeItem.bind(this)
    this.handleUpdateParent = this.handleUpdateParent.bind(this)
    this.filterItems = this.filterItems.bind(this)
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this)
    this.handleUpdateSort = this.handleUpdateSort.bind(this)
  }

  componentDidMount() {
    this.props.handleUpdateSearchTerm()
  }

  handleUpdateSort(sortName, sortOrder) {
    this.setState({ sort: sortName, sortOrder })
  }

  showForm(show, chargeItem) {
    this.setState({
      showForm: show,
      chargeItem,
      lastUpsertedItemId: null,
    })
  }

  handleCreateChargeItem(chargeItem) {
    let oldItems = [...this.state.chargeItems]

    if (isListedPumpPrice(chargeItem)) {
      // if the newly created chargeItem is a listed_pump_price, remove the 'fake' one before adding the real one
      oldItems = oldItems.filter((obj) => obj.name !== chargeItem.name)
    }

    this.setState({
      chargeItems: [chargeItem, ...oldItems],
      chargeItem: null,
      showForm: false,
      lastUpsertedItemId: chargeItem.id,
    })
    afterSetState(this.handleUpdateParent)
  }

  handleUpdateChargeItem(chargeItem) {
    let predicate = { id: chargeItem.id }
    if (!chargeItem.id && isListedPumpPrice(chargeItem)) {
      predicate = { name: chargeItem.name }
    }

    // Replace _.findIndex with native findIndex
    const index = this.state.chargeItems.findIndex((item) => {
      if (predicate.id !== undefined) {
        return item.id === predicate.id
      }
      return item.name === predicate.name
    })

    // Replace _.clone with spread operator
    const items = [...this.state.chargeItems]
    items[index] = chargeItem

    this.setState({
      ...(isListedPumpPrice(chargeItem) && {
        listedPumpPriceLastUpdatedAt: chargeItem.lastUpdatedAt,
      }),
      chargeItems: items,
      chargeItem: null,
      showForm: false,
      lastUpsertedItemId: chargeItem.id,
    })
    afterSetState(this.handleUpdateParent)
  }

  handleDeleteChargeItem(chargeItem) {
    if (
      window.confirm(`Are you sure you to delete the item ${chargeItem.name}?`)
    ) {
      this.setState({ processingDelete: chargeItem.id })
      $.delete(
        buildRoute($context.updateUrl, { charge_item_id: chargeItem.id }),
        () => {
          this.setState({
            processingDelete: false,
            chargeItems: this.state.chargeItems.filter(
              (item) => item.id !== chargeItem.id
            ),
            chargeItem: null,
            showForm: false,
          })
          afterSetState(this.handleUpdateParent)
        }
      )
    }
  }

  handleUpdateParent() {
    if (this.props.handleUpdateItems) {
      this.props.handleUpdateItems(
        this.state.chargeItems,
        this.state.listedPumpPriceLastUpdatedAt
      )
    }
  }

  sortedChargeItems() {
    // Define sort function to get the value to sort by
    const sortBy = (chargeItem) => {
      // Handle potential undefined/null values and convert to lowercase
      return chargeItem[this.state.sort]?.toLowerCase() || ""
    }

    // Use the shared orderBy utility
    return orderBy(this.state.chargeItems, sortBy, this.state.sortOrder)
  }

  filterItems(items, searchTerm) {
    if (!items) return []

    return items.filter((item) => {
      if (!item || !item.name) return false
      return item.name.toLowerCase().includes(searchTerm)
    })
  }

  handleSearchInputChange(term) {
    const filteredChargeItems = this.filterItems(
      this.props.chargeItems,
      term.toLowerCase()
    )
    this.setState({ searchTerm: term, chargeItems: filteredChargeItems })
  }

  componentDidUpdate(prev, prevState) {
    if (prev.searchTerm !== this.props.searchTerm) {
      this.handleSearchInputChange(this.props.searchTerm)
    }
  }

  renderForm() {
    if (this.state.showForm) {
      return (
        <ChargeItemForm
          {...this.props.createChargeProps}
          chargeItem={this.state.chargeItem}
          showForm={this.showForm}
          createChargeItem={this.handleCreateChargeItem}
          updateChargeItem={this.handleUpdateChargeItem}
          deleteChargeItem={this.handleDeleteChargeItem}
          processingDelete={this.state.processingDelete}
        />
      )
    } else {
      return (
        <div className="my-4 flex flex-wrap-reverse justify-between md:mt-2">
          <SortButtonsBar
            buttons={[
              { name: "name" },
              { name: "category" },
              { name: "createdAt", title: "Date Added" },
            ]}
            sort={this.state.sort}
            sortOrder={this.state.sortOrder}
            updateSort={this.handleUpdateSort}
          />
          <button
            type="button"
            className="btn btn-primary mb-4 sm:mb-0"
            onClick={() => this.showForm(true, null)}
          >
            + Create a new charge item
          </button>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <div className="edit-items-form-container container sticky rounded-t border border-b-0 border-solid bg-white pb-3 pt-3 shadow">
          {this.renderForm()}
        </div>
        <div className="mb-5 rounded-b border border-t-0 border-solid bg-white p-5">
          <ChargeItemsList
            chargeItems={this.sortedChargeItems()}
            listedPumpPriceLastUpdatedAt={
              this.state.listedPumpPriceLastUpdatedAt
            }
            selectedChargeItemId={
              this.state.chargeItem && this.state.chargeItem.id
            }
            showForm={this.showForm}
            lastUpsertedItemId={this.state.lastUpsertedItemId}
            deleteChargeItem={this.handleDeleteChargeItem}
            processingDelete={this.state.processingDelete}
            renderTaxRate={this.props.renderTaxRate}
          />
        </div>
      </div>
    )
  }
}

ChargeItemsController.propTypes = {
  chargeItems: PropTypes.array.isRequired,
  listedPumpPriceLastUpdatedAt: PropTypes.string,
  searchTerm: PropTypes.string,
  handleUpdateSearchTerm: PropTypes.func,
  handleUpdateItems: PropTypes.func,
  renderTaxRate: PropTypes.func.isRequired,
  createChargeProps: PropTypes.object,
}

export default ChargeItemsController
